var map = {
	"./Bronze_1.png": [
		71282,
		1282
	],
	"./Bronze_2.png": [
		94703,
		4703
	],
	"./Bronze_3.png": [
		97879,
		7879
	],
	"./Champion.png": [
		12223,
		2223
	],
	"./Diamond_1.png": [
		88195,
		8195
	],
	"./Diamond_2.png": [
		56353,
		6353
	],
	"./Diamond_3.png": [
		2268,
		2268
	],
	"./Elite.png": [
		45291,
		5291
	],
	"./Gold_1.png": [
		78791,
		8791
	],
	"./Gold_2.png": [
		61917,
		1917
	],
	"./Gold_3.png": [
		8364,
		8364
	],
	"./Platinum_1.png": [
		30047,
		47
	],
	"./Platinum_2.png": [
		12783,
		2783
	],
	"./Platinum_3.png": [
		2297,
		2297
	],
	"./Silver_1.png": [
		34806,
		4806
	],
	"./Silver_2.png": [
		22335,
		8862
	],
	"./Silver_3.png": [
		15776,
		5776
	],
	"./Unranked.png": [
		32470,
		2470
	],
	"./Unreal.png": [
		63385,
		3385
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2047;
module.exports = webpackAsyncContext;